<div class="make-changes-text">
  <a
    [href]="nativeTrackingUrl"
    target="_blank"
    [trackable]="trackableUrl"
    [style.--text-color]="textColor"
    [style.--font-weight]="fontWeight">
    {{ linkText }}
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.0835 6.91683L6.91683 1.0835"
        stroke="#4B3BFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        attr.fill="{{ textColor }}"
        attr.stroke="{{ textColor }}" />
      <path
        d=" M1.0835 1.0835H6.91683V6.91683
            "
        stroke="#4B3BFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        attr.fill="{{ textColor }}"
        attr.stroke="{{ textColor }}" />
    </svg>
  </a>
</div>
